import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
    selector: 'app-dialog-info',
    templateUrl: './dialog-info.component.html',
    styleUrls: ['./dialog-info.component.scss'],
    standalone: false
})
export class DialogInfoComponent implements OnInit {
	@Output() passEntry: EventEmitter<any> = new EventEmitter();
	@Input() loading: boolean;
	@Input() msgVald: number;
	@Input() mainTitle: string;
	@Input() mainMessage: string;

	errorMessage: string = '';
	public _success = new Subject<string>();
	private _error = new Subject<string>();
	successMessage = '';
	constructor(
		public activeModal: NgbActiveModal,
	) { }
  ngOnInit() {
		this.messageValidation();
	}
	ngOnChanges(changes: SimpleChanges): void {
	}
	closeModal() {
		this.activeModal.close('Modal Closed');
	}
	confirmDelete() {
		this.passEntry.emit(true);
	}
	messageValidation() {

	}
}
